import { combineReducers } from 'redux';

import userContractReducer from './userContractReducer';
import userAgreementReducer from './userAgreementReducer';
import registerValidateReducer from './registerValidateReducer';
import registerReducer from './registerReducer';
import otpReducer from './otpReducer';
import kvkkReducer from './kvkkReducer';
import registeredCampaignsReducer from './registeredCampaignsReducer';
import forgotPasswordReducer from './ForgotPassword';
import commercialMessageAgreementReducer from './CommercialMessageAgreementReducer';
import raffleCommercialMessageAgreementReducer from './RaffleCommercialMessageAgreementReducer';

export default combineReducers({
  commercialMessageAgreement: commercialMessageAgreementReducer,
  userContract: userContractReducer,
  userAgreement: userAgreementReducer,
  forgotPassword: forgotPasswordReducer,
  registerValidate: registerValidateReducer,
  register: registerReducer,
  otp: otpReducer,
  kvkk: kvkkReducer,
  registeredCampaigns: registeredCampaignsReducer,
  raffleCommercialMessageAgreement: raffleCommercialMessageAgreementReducer,
});
